import { styled } from '@mui/material/styles';

/**
 * Elevated white card — the kit's base card shell. Callers override the
 * border/shadow tier and padding via `sx`.
 */
const Card = styled('div')(({ theme }) => ({
  background: theme.palette.common.white,
  border: `1px solid ${theme.palette.staticPages.border.card}`,
  borderRadius: theme.shape.borderRadius * 4,
  boxShadow: theme.palette.staticPages.shadow.md,
}));

export default Card;
